'use strict'

import React from 'react';

import SettingsForUsage from './SettingsForUsage.jsx';

export default class BusinessCaseSettings extends React.Component {
  render() {
    return (
      <SettingsForUsage
        {...this.props}
        image="/images/business_case_s1.png"
        area="businessCase"
        label="Business Case"
        help="Turn on or off use of Business Case."
      />
    );
  }
}



// WEBPACK FOOTER //
// ./views/settings/BusinessCaseSettings.jsx